import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from './base-query';

const productAPI = createApi({
    reducerPath: "productAPI",
    baseQuery,
    endpoints: (builder) => ({
        getAllProductsWithoutPage: builder.query({
            query: () => {
                let apiUrl = `admin/data/product`;

                return {
                    url: apiUrl,
                    method: "GET",
                };
            },
            transformResponse: (response) => response,
            providesTags: ["all_products"],
        }),
        getAllProducts: builder.mutation({
            query: ({ page, size, key }) => {
                let apiUrl = `admin/product?page=${page}&limit=${size}`;

                if (key) {
                    apiUrl += `&search=${key}`;
                }

                return {
                    url: apiUrl,
                    method: "GET",
                };
            },
            transformResponse: (response) => response,
            providesTags: ["products"],
        }),
        getSpecificProductDetails: builder.mutation({
            query: ({ id }) => {
                let apiUrl = `admin/product/${id}`;

                return {
                    url: apiUrl,
                    method: "GET",
                };
            },
            transformResponse: (response) => response
        }),
        createProduct: builder.mutation({
            query: ({ data }) => {
                return {
                    url: "admin/product",
                    method: "POST",
                    body: data
                };
            },
            invalidatesTags: ["products"],
        }),
        updateProduct: builder.mutation({
            query: ({ data }) => {
                return {
                    url: `admin/product`,
                    method: "PUT",
                    body: data
                };
            },
            invalidatesTags: ["products"],
        }),
        deleteProduct: builder.mutation({
            query: ({ id }) => {
                return {
                    url: `admin/product/${id}`,
                    method: "DELETE"
                };
            },
            invalidatesTags: ["products"],
        }),

        updateProductPrice: builder.mutation({
            query: ({ data }) => {
                return {
                    url: `admin/product/price`,
                    method: "PUT",
                    body: data
                };
            },
            invalidatesTags: ["products"],
        }),
        updateProductDiscount: builder.mutation({
            query: ({ data }) => {
                return {
                    url: `admin/product/discount`,
                    method: "PUT",
                    body: data
                };
            },
            invalidatesTags: ["products"],
        }),

        getSpecificProductStockList: builder.mutation({
            query: ({ productId, page, size }) => {
                let apiUrl = `admin/product/${productId}/stock-entry?page=${page}&limit=${size}`;

                return {
                    url: apiUrl,
                    method: "GET",
                };
            },
            transformResponse: (response) => response,
            providesTags: ["stocks"],
        }),
        addNewStock: builder.mutation({
            query: ({ productId, data }) => {
                return {
                    url: `admin/product/${productId}/stock-entry`,
                    method: "POST",
                    body: data
                };
            },
            invalidatesTags: ["stocks"],
        }),
        removeStock: builder.mutation({
            query: ({ productId, stockId }) => {
                return {
                    url: `admin/product/${productId}/stock-entry/${stockId}`,
                    method: "DELETE"
                };
            },
            invalidatesTags: ["stocks"],
        }),

        getPriceLogsOfProduct: builder.mutation({
            query: ({ page, size, productId }) => {
                let apiUrl = `admin/product/${productId}/price-log?page=${page}&limit=${size}`;

                return {
                    url: apiUrl,
                    method: "GET",
                };
            },
            transformResponse: (response) => response,
            providesTags: ["price_logs"],
        }),

        getProductInsights: builder.mutation({
            query: ({ startDate, endDate }) => {
                let apiUrl = `admin/product/insight?startDate=${startDate}&endDate=${endDate}`;

                return {
                    url: apiUrl,
                    method: "GET",
                };
            },
            transformResponse: (response) => response,
            providesTags: ["products_insights"],
        }),

        syncProducts: builder.mutation({
            query: ({ data }) => {
                return {
                    url: "admin/quickbook/product/sync-by-time",
                    method: "POST",
                    body: data
                };
            }
        }),
    })
});

export const { 
    useGetAllProductsWithoutPageQuery,
    useGetAllProductsMutation,
    useGetSpecificProductDetailsMutation,
    useCreateProductMutation,
    useUpdateProductMutation,
    useDeleteProductMutation,

    useUpdateProductPriceMutation,
    useUpdateProductDiscountMutation,

    useGetSpecificProductStockListMutation,
    useAddNewStockMutation,
    useRemoveStockMutation,

    useGetPriceLogsOfProductMutation,

    useGetProductInsightsMutation,

    useSyncProductsMutation
} = productAPI;

export default productAPI;